import { useEffect, useRef, useState } from "react";
import Peer from "peerjs";
import socket from "../socket";

export const usePeerConnection = (aid, localStream) => {
  const [connected, setConnected] = useState(false);
  const remoteVideoRef = useRef(null);
  const peerRef = useRef(null);

  useEffect(() => {
    if (!aid || !localStream) return;

    const peer = new Peer(aid, {
      host: "live.claimsmitra.com",
      port: 443,
      path: "/peerjs",
      secure: true,
      config: {
        iceServers: [
          { urls: "stun:stun.l.google.com:19302" },
          {
            urls: [
              "turn:187.127.154.93:3478?transport=udp",
              "turn:187.127.154.93:3478?transport=tcp",
              "turns:187.127.154.93:5349?transport=tcp",
            ],
            username: "username1",
            credential: "password1",
          },
        ],
      },
    });

    peerRef.current = peer;

    peer.on("open", (id) => {
      console.log("✅ Surveyor Peer connected:", id);

      socket.emit("join", { aid, role: "surveyor" });
    });

    // ✅ IMPORTANT: ALWAYS ANSWER CALL
    peer.on("call", (call) => {
      console.log("📞 Incoming call from insured");

      call.answer(localStream); // send surveyor stream

      call.on("stream", (remoteStream) => {
        console.log("🎥 Received insured stream");

        if (remoteVideoRef.current) {
          remoteVideoRef.current.srcObject = remoteStream;
        }

        setConnected(true);
      });
    });

    // ✅ EXTRA SAFETY: FORCE CALL BACK (fixes blank screen issue)
    socket.on("ready", (users) => {
      if (users.insured && users.surveyor) {
        console.log("🔁 Forcing call from surveyor");

        const call = peer.call(aid, localStream);

        call.on("stream", (remoteStream) => {
          console.log("🎥 Received stream (forced)");

          if (remoteVideoRef.current) {
            remoteVideoRef.current.srcObject = remoteStream;
          }

          setConnected(true);
        });
      }
    });

    return () => {
      peer.destroy();
    };
  }, [aid, localStream]);

  return { remoteVideoRef, connected };
};


// import { useEffect, useRef, useState } from "react";
// import Peer from "peerjs";
// import socket from "../socket";

// export const usePeerConnection = (peerId, localStream, remotePeerId) => {
//   const [connected, setConnected] = useState(false);
//   const remoteVideoRef = useRef(null);
//   const peerRef = useRef(null);

//   useEffect(() => {
//     if (!peerId || !localStream) return;

//     const peer = new Peer(peerId, {
//       host: "live.claimsmitra.com",
//       port: 443,
//       secure: true,
//       path: "/peerjs"
//     });

//     peerRef.current = peer;

//     peer.on("open", (id) => {
//       console.log("✅ Peer ready:", id);

//       socket.emit("join", {
//         peerId: id,
//         role: "surveyor",
//       });
//     });

//     // 📞 RECEIVING CALL (INSURED → SURVEYOR)
//     peer.on("call", (call) => {
//       console.log("📞 Incoming call");

//       call.answer(localStream);

//       call.on("stream", (stream) => {
//         console.log("🎥 Remote stream received");

//         if (remoteVideoRef.current) {
//           remoteVideoRef.current.srcObject = stream;
//         }

//         setConnected(true);
//       });
//     });

//     return () => {
//       peer.destroy();
//     };
//   }, [peerId, localStream]);

//   // 📞 OUTGOING CALL (SURVEYOR → INSURED)
//   useEffect(() => {
//     if (!peerRef.current || !remotePeerId || !localStream) return;

//     console.log("📡 Calling insured:", remotePeerId);

//     const call = peerRef.current.call(remotePeerId, localStream);

//     call.on("stream", (stream) => {
//       console.log("🎥 Incoming remote stream (outgoing)");

//       if (remoteVideoRef.current) {
//         remoteVideoRef.current.srcObject = stream;
//       }

//       setConnected(true);
//     });

//     call.on("error", (err) => {
//       console.log("❌ Call error:", err);
//     });

//   }, [remotePeerId, localStream]);

//   return { remoteVideoRef, connected };
// };